// Built-ins
import React from "react";

// Modules
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

// CSS
import "react-tabs/style/react-tabs.css";

// Custom Made Components
import NavigationBar from "../../core/navigation_bar/navigation_bar";
import Footer from "../../core/footer/footer";
import TheaterOverView from "./theater_overview/theater_overview";
import Gallery from "../../core/gallery/gallery";
import Documents from "../../core/documents/documents";
import TheaterGroups from "./theater_groups/theater_groups";
// Global Variables
import {
  headers,
  restrictedUsers,
} from "../../global_vars";

import axios from "axios";
import Swal from "sweetalert2";

// Variables
window.Swal = Swal;

function getTheaterId() {
  return window.location.pathname.split("/")[3];
}


// Variables
const VIEW_THEATER = "https://groupplan.gr/api/data_management/theater/";

// theater page Class
class Theater extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      theater: {},
      is_loaded: false,
    };
  }

  componentDidMount() {
    if (restrictedUsers().includes(localStorage.getItem("user"))) {
      this.setState({
        forbidden: true,
      });
    }
    headers["Authorization"] = "Token " + localStorage.getItem("userToken");
    axios
      .get(VIEW_THEATER + getTheaterId(), {
        headers: headers,
      })
      .then((res) => {
        this.setState({
          theater: res.data.theater,
          is_loaded: true,
        });
      })
      .catch((e) => {
        if (e.response.status === 401) {
          this.setState({
            forbidden: true,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An unknown error has occured.",
          });
        }
      });
  }

  update_state = () => {
    headers["Authorization"] = "Token " + localStorage.getItem("userToken");
    axios
      .get(VIEW_THEATER + getTheaterId(), {
        headers: headers,
      })
      .then((res) => {
        this.setState({
          theater: res.data.theater,
          is_loaded: true,
        });
      })
      .catch((e) => {
        if (e.response.status === 401) {
          this.setState({
            forbidden: true,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An unknown error has occured.",
          });
        }
      });
  };

  render() {
    return (
      <div>
        <NavigationBar />
        <Tabs>
          <TabList>
            <Tab>Overview</Tab>
            <Tab>Gallery</Tab>
            <Tab>Documents</Tab>
            <Tab>Groups</Tab>
          </TabList>
          <TabPanel>
            <TheaterOverView />
          </TabPanel>
          <TabPanel>
            <Gallery object={this.state.theater} object_type={"Theater"} />
          </TabPanel>
          <TabPanel>
            <Documents object={this.state.theater} is_loaded={this.state.is_loaded} object_type={"Theater"} update_state={this.update_state} />
          </TabPanel>
          <TabPanel>
            <TheaterGroups />
          </TabPanel>
        </Tabs>
        <Footer />
      </div>
    );
  }
}

export default Theater;
